import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AccountBanner } from 'components/account/AccountBanner';
import { DefaultLayout } from 'components/page/layouts/DefaultLayout';

export const GuestModeBanner: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <DefaultLayout>
      {/* Alert info color does not match w/ the MUI library blue || lightBlue palettes */}
      <AccountBanner
        id="guest-mode-banner"
        severity="info"
        onClick={() => navigate('/signin', { state: { from: location } })}
        sx={{ backgroundColor: '#e5f6fd' }}
        alertSx={{ paddingInline: 0 }}
      >
        {t('guest.banner')}
      </AccountBanner>
    </DefaultLayout>
  );
};
